define('lq/events/actions/chatGPTCommand',[
    'lq/events/actions/eventAction',
    'lq/chatHub',
    'uuid'
], function(EventAction, chatHub, uuid) {
    'use strict';
    
    function ChatGPTCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        this.groupId = uuid();
        return this;
    };

    EventAction.extend(ChatGPTCommand, EventAction);

    ChatGPTCommand.typeName = 'ChatGPTCommand';

    ChatGPTCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ChatGPTCommand.prototype.createEventActionRequest = function () {
        var self = this;

        if (this.shouldListenForStream()) {
            chatHub.startListeningAndSubscribe('ChatGPTStream', function (message) {
                if(self.eventIsEnabled('streaming')) {
                    self.fullMessage = (self.fullMessage || '') + message;
                    self.triggerEvent('streaming', undefined, self.fullMessage);
                }
                self.triggerEventIfEnabled('streamingSection', undefined, message);
            }, { groupId: self.groupId });
        }
            

        return {
            eventActionType: 'ChatGPT',
            command: this.eventData.command,
            groupId: this.groupId
        };
    };

    ChatGPTCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (this.shouldListenForStream())
            chatHub.stopListeningAndUnsubscribe('ChatGPTStream', { groupId: this.groupId });
        continuation();
    };

    ChatGPTCommand.prototype.shouldListenForStream = function () {
        return this.eventData.eventing &&
            (
                (this.eventData.eventing['streaming'] &&
                    this.eventData.eventing['streaming'].enabled) ||

                (this.eventData.eventing['streamingSection'] &&
                    this.eventData.eventing['streamingSection'].enabled)
            );
    };

    return ChatGPTCommand;
});
